module.exports = new __parcel__URL__("periscope-page.tpl.96086563.svg").toString();